import TextEditor from '@/components/common/texteditor/TextEditor.vue'
import EmailTemplateParams from '@/components/configs/emails/templateparams/EmailTemplateParams.vue'
import MessageBox from '@/components/common/messagebox/MessageBox.vue'
import MultilangInput from '@/components/common/multilanginput/MultilangInput.vue'
import Fileupload from '@/components/common/fileupload/Fileupload.vue';

export default {
  name: 'EmailManualSend',
  data () {
    return {
      email: {
        createCustomMessage: true,
        sendAsMyself: true,
        message: null,
        template: null,
        receivers: [],
        messagetext: {},
        title: {},
        files: []
      },
      loading: false,
      emailMessageOptions: null,
      emailTemplateOptions: null
    }
  },
  components: {
    EmailTemplateParams,
    MultilangInput,
    MessageBox,
    TextEditor,
    Fileupload
  },
  computed: {
    getTitle () {
      return this.$t('menu.config.emails.messages.new-info');
    },
    userChecklistFilters () {
      const filters = {};
      filters.managers = { type: 'checkbox', label: this.$t('client.manager'), options: this.managerOptions, defaultValue: [], valueField: 'api_id' };
      filters.client_classification_group = { type: 'checkbox', label: this.$t('client.category'), options: this.clientClassificationGroupOptions, defaultValue: [] };
      filters.client_activeContract = {
        type: 'checkbox',
        label: this.$t('client.name') + ' - ' + this.$t('client.filters.activeContract'),
        options: this.materialGroupOptions,
        defaultValue: this.materialGroupOptions.map(function (val) {
          return val.code;
        })
      }
      filters.noSeminarSince = { type: 'date', label: this.$t('seminar.user.noSeminarSince'), defaultValue: '' };
      filters.client_primaryFillerUpdatedSince = { type: 'date', label: this.$t('client.name') + ' - ' + this.$t('client.primaryFillerUpdatedSince'), defaultValue: '' };
      filters.report_notFilledPeriod = { type: 'date-period', label: this.$t('report.notFilledPeriod'), defaultValue: null }
      filters.seminarRejectInvite = { type: 'checkbox', label: this.$t('user.seminarRejectInvite'), options: this.yesNoOptions, defaultValue: [], class: 'col-md-2' };
      filters.client_isPrimaryReportFiller = { type: 'checkbox', label: this.$t('user.isPrimaryReportFiller'), options: this.yesNoOptions, defaultValue: [], class: 'col-md-2' };
      filters.client_isBlocked = { type: 'checkbox', label: this.$t('client.name') + ' - ' + this.$t('client.isBlocked'), options: this.yesNoOptions, defaultValue: [0], class: 'col-md-2' };
      filters.client_canFillReports = { type: 'checkbox', label: this.$t('user.pivot.canFillReports'), options: this.yesNoOptions, defaultValue: [], class: 'col-md-2' };
      filters.client_isContactPerson = { type: 'checkbox', label: this.$t('client.name') + ' - ' + this.$t('user.pivot.isContactPerson'), options: this.yesNoOptions, defaultValue: [], class: 'col-md-2' };
      filters.client_isResponsiblePerson = { type: 'checkbox', label: this.$t('client.name') + ' - ' + this.$t('user.pivot.isResponsiblePerson'), options: this.yesNoOptions, defaultValue: [], class: 'col-md-2' };
      filters.client_receiveBill = { type: 'checkbox', label: this.$t('client.name') + ' - ' + this.$t('user.pivot.receiveBill'), options: this.yesNoOptions, defaultValue: [], class: 'col-md-2' };
      filters.client_receiveNotifications = { type: 'checkbox', label: this.$t('client.name') + ' - ' + this.$t('user.pivot.receiveNotifications'), options: this.yesNoOptions, defaultValue: [], class: 'col-md-2' };

      return filters;
    },
    clientClassificationGroupOptions () {
      return this.ZPFormatHelper.getClassificationGroupFilterOptions();
    },
    materialGroupOptions () {
      return this.$store.getters.getConfigOptions('material_groups', this.$i18n.locale, 'disabled', 0);
    },
    yesNoOptions () {
      return this.BasicHelper.yesNoOptions();
    },
    managerOptions () {
      return this.$store.getters.getConfigOptions('managers');
    }
  },
  methods: {
    close () {
      this.$refs['modal-window'].hide();
    },
    show () {
      this.$refs['modal-window'].show();
    },
    getTemplateMessageOptions () {
      const self = this;
      self.loading = true;
      this.ApiRequest.request('config/emails/config', this.ApiRequest.REQUEST_GET, { }, function (response) {
        if (response.data) {
          self.emailMessageOptions = response.data.messages;
          self.email.message = self.emailMessageOptions[0].code;
          const options = response.data.templates;
          options.unshift({ code: '', id: null });
          self.emailTemplateOptions = options;
        }
        self.loading = false;
      });
    },
    getFullUserName (item) {
      return '|B|' + item.name + '|| (' + item.email + ' - ' + item.defaultLang + ')' + '|BR|' + item.clientNames;
    },
    send (item, approved = 0) {
      if (approved) {
        this.loading = true;
        this.email.users = this.email.receivers.map(el => el.api_id);
        const reqData = this.ApiRequest.createFormData(this.email, ['createCustomMessage', 'message', 'template', 'title', 'messagetext', 'users', 'sendAsMyself'], 'message', this);
        const self = this;
        this.ApiRequest.request('config/emails/add-mail-messages', this.ApiRequest.REQUEST_FILEUPLOAD, reqData, function (response) {
          if (response.data.success) {
            self.close();
          } else {
            self.ApiRequest.displayErrorDialog(response, self);
          }
          self.loading = false;
        });
      } else {
        this.$refs.manualSendMsgBox.show(
          item,
          this.$t('menu.config.emails.manualSendApprove.title'),
          this.$t('menu.config.emails.manualSendApprove.message')
        );
      }
    }
  },
  mounted () {
    this.getTemplateMessageOptions();
  }
}
